import { configureStore } from "@reduxjs/toolkit";

import userReducer from "../pages/userSlice";
import listUsersSlice from "../parts/listUsers/listUsersSlice";
import businessGroupSlice from "../parts/businessGroup/businessGroupSlice";
import rateSlice from "../parts/rate/rateSlice";
import geographiesSlice from "../parts/geographies/geographiesSlice";

export default configureStore({
  reducer: {
    user: userReducer,
    listUsers: listUsersSlice,
    businessGroup: businessGroupSlice,
    rate: rateSlice,
    geographies: geographiesSlice,
  },
});
